import axios from '@/utils/request.js'

export const getSettleList = (params) => {
  // 公司钢瓶信息
  return axios.post('/goods/gas/company/getCompanyGasInfo', params)
}

export const searchGasByCode = (params) => {
  // 搜索钢瓶
  return axios.post('/goods/gas/company/searchGasByCode', params)
}

export const getAgentMesslist = (id) => {
  // 钢瓶流通管理详情
  return axios.get(`/goods/bGlmCylinderCurrentStatus/getAgentMesslist/${id}`)
}

export const getAgentCustomerMesslist = (params) => {
  // 钢瓶流通管理详情
  return axios.post(
    '/goods/bGlmCylinderCurrentStatus/getAgentCustomerMesslist',
    params
  )
}

export const getCylinderNotFlowList = (params) => {
  // 查询钢瓶检测日期列表
  return axios.post('/goods/gas/cylinder/getCylinderNotFlowList', params)
}

export const getCylinderExpList = (params) => {
  // 查询钢瓶未流通日期列表
  return axios.post('/goods/gas/cylinder/getCylinderExpList', params)
}

export const getAllCylinderNotFlowList = (params) => {
  // 未流通钢瓶(所有公司)
  return axios.post('/goods/gas/cylinder/getAllCylinderNotFlowList', params)
}

export const getAllCylinderExpList = (params) => {
  // 到期检测钢瓶(所有公司)
  return axios.post('/goods/gas/cylinder/getAllCylinderExpList', params)
}

export const getCyListByStatus = (params) => {
  // 钢瓶列表 充气 入库
  return axios.post('/goods/gas/cylinder/getCyListByStatus', params)
}

export const agentStoreApply = (params) => {
  // 钢瓶列表 入库确认
  return axios.post('/goods/gas/cylinder/agentStoreApply', params)
}

export const agentFillApply = (params) => {
  // 钢瓶列表 充气确认
  return axios.post('/goods/gas/cylinder/agentFillApply', params)
}
export const agentCylinderTrans = (params) => {
  // 钢瓶列表 移交确认
  return axios.post('/goods/gas/cylinder/agentCylinderTrans', params)
}
export const getTransDept = (params) => {
  // 销售部列表
  return axios.post('/goods/gas/cylinder/getTransDept', params)
}
export const getTransHisList = (params) => {
  // 移交历史
  return axios.post('/goods/gas/cylinder/getTransHisList', params)
}
export const getOverdueCylinderListByDeptId = (params) => {
  // 送检
  return axios.post(
    '/goods/gas/cylinder/getOverdueCylinderListByDeptId',
    params
  )
}
export const getCylinderMessListByDeptIdForOverdue = (params) => {
  return axios.post(
    '/goods/gas/cylinder/getCylinderMessListByDeptIdForOverdue',
    params
  )
}
export const addCylinderCheck = (params) => {
  return axios.post('/goods/gas/cylinder/addCylinderCheck', params)
}
export const getCylinderMessListByDeptId = (params) => {
  return axios.post('/goods/gas/cylinder/getCylinderMessListByDeptId', params)
}
export const updateCylinderCustodyById = (params) => {
  return axios.post('/goods/gas/cylinder/updateCylinderCustodyById', params)
}

export const getCylinderCustodyMessListByComId = (params) => { // 查询钢瓶托管列表
  return axios.post('/goods/gas/cylinder/getCylinderCustodyMessListByComId', params)
}
